import React from "react"
import { FormGroup, Label, FormFeedback } from "reactstrap"

const CheckboxInput = ({
    label,
    name,
    validation,
    helperText,
    readOnly = false,
    className = "",
    emptyText, // Custom empty text for readonly mode
    trueText = "Enabled", // Text to show when checked
    falseText = "", // Text to show when unchecked
    checkboxLabel = "Enable", // Label next to the checkbox
    hideInReadonlyWhenEmpty = false, // Hide entire component in readonly if no data
    dependentField, // Field to check for hiding (e.g., "accountLegalName")
    onValueChange, // Optional callback when value changes
    ...rest
}) => {
    const showHelperText = !readOnly && helperText
    const hasError = validation.touched[name] && validation.errors[name]
    const checkboxValue = validation.values[name]
    const dependentValue = dependentField ? validation.values[dependentField] : true

    // Hide component if specified conditions are met
    if (hideInReadonlyWhenEmpty && readOnly && !dependentValue) {
        return null
    }

    // Handle checkbox click
    const handleClick = () => {
        const newValue = !checkboxValue
        validation.setFieldValue(name, newValue)
        if (onValueChange) {
            onValueChange(newValue)
        }
    }

    return (
        <FormGroup className={`mb-3 ${className}`}>
            {label && (
                <Label className="form-label">
                    {label}
                </Label>
            )}

            {!readOnly ? (
                <div className="form-check form-check-primary">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        id={name}
                        name={name}
                        {...rest}
                        checked={!!checkboxValue}
                        onChange={() => {}}
                        onClick={handleClick}
                        onBlur={validation.handleBlur}
                    />
                    <label
                        className="form-check-label"
                        htmlFor={name}
                    >
                        {checkboxLabel}
                    </label>
                </div>
            ) : (
                <div className="form-control input-as-text d-flex align-items-center">
                    <span>
                        {checkboxValue === true ? trueText : falseText}
                    </span>
                </div>
            )}

            {hasError ? (
                <FormFeedback type="invalid" className="d-block">
                    {validation.errors[name]}
                </FormFeedback>
            ) : null}

            {showHelperText && (
                <span className="text-muted text-end d-inline-block w-100">
                    {helperText}
                </span>
            )}
        </FormGroup>
    )
}

export default CheckboxInput